
import { defineComponent, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import { themeLightLogoIconText } from "@/core/helpers/config";
import { getIllustrationsPath } from "@/core/helpers/assets";
import { I18nUtils } from "@/sea/utils/I18nUtils";

export default defineComponent({
  name: "error-500",
  components: {},
  setup() {
    const store = useStore();

    onMounted(() => {
      store.dispatch(Actions.ADD_BODY_CLASSNAME, "bg-body");
    });

    onUnmounted(() => {
      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "bg-body");
    });

    return {
      themeLightLogoIconText,
      getIllustrationsPath,
      I18nUtils,
    };
  },
});
